import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const linkBase =
  "relative text-sm font-medium text-gray-700 transition-colors duration-200";
const linkUnderline =
  "after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-blue-600 after:transition-all after:duration-300 hover:after:w-full";
const linkActive = "text-gray-900 after:w-full";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const navLinkClass = ({ isActive }) =>
    `${linkBase} ${linkUnderline} ${isActive ? linkActive : ""}`;

  return (
    <header className="border-b bg-white">
      <div className="mx-auto max-w-6xl px-4">
        <div className="flex h-16 items-center justify-between">
          
          {/* Logo */}
          <NavLink to="/" className="text-xl font-bold text-gray-900">
            Trusted Wrench
          </NavLink>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            <NavLink to="/" className={navLinkClass}>
              Home
            </NavLink>
            <NavLink to="/about" className={navLinkClass}>
              About Us
            </NavLink>
            <NavLink to="/services" className={navLinkClass}>
              Services
            </NavLink>
            <NavLink to="/contact" className={navLinkClass}>
              Contact Us
            </NavLink>
            <NavLink to="/quote" className={navLinkClass}>
              Request a Quote
            </NavLink>
          </nav>

          {/* Mobile Toggle */}
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden rounded-lg border border-gray-300 p-2 text-gray-700 hover:bg-gray-100"
            aria-label="Toggle menu"
          >
            <svg
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              {open ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden border-t bg-white">
          <nav className="flex flex-col gap-4 px-4 py-4">
            <NavLink onClick={() => setOpen(false)} to="/" className={navLinkClass}>
              Home
            </NavLink>
            <NavLink onClick={() => setOpen(false)} to="/about" className={navLinkClass}>
              About Us
            </NavLink>
            <NavLink onClick={() => setOpen(false)} to="/services" className={navLinkClass}>
              Services
            </NavLink>
            <NavLink onClick={() => setOpen(false)} to="/contact" className={navLinkClass}>
              Contact Us
            </NavLink>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
